import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteJustificativaAlteracaoEncerrante,
  findJustificativaAlteracaoEncerrante,
  recordFiltering,
} from '~/store/modules/justificativaAlteracaoEncerrante/actions';

import Form from './form';

function JustificativaAlteracaoEncerranteList() {
  const redux = useSelector((state) => state.justificativaAlteracaoEncerrante);

  const options = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'descricaojustificativaalteracaoencerrante',
        label: t(
          's.configuracao.justificativaalteracaoencerrante.descricaojustificativaalteracaoencerrante'
        ),
        filter: { type: 'text' },
      },
      {
        id: 'statusjustificativaalteracaoencerrante',
        label: t(
          's.configuracao.justificativaalteracaoencerrante.statusjustificativaalteracaoencerrante'
        ),
        formatted: (value) =>
          options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },
    ],
    [options]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findJustificativaAlteracaoEncerrante}
      remove={deleteJustificativaAlteracaoEncerrante}
      form={Form}
      keys="idjustificativaalteracaoencerrante"
      detach="justificativaAlteracaoEncerrante"
    />
  );
}

export default JustificativaAlteracaoEncerranteList;
